export const emailVerifier = {
	data() {
		return {
			reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
		}
	},
	methods: {
		isEmailValid: function(email) {
      return (email == "")? "" : (this.reg.test(email))
    }
	}
}

export const phoneNumberVerifier = {
	data() {
		return {
			phoneNumberMask: '(###) ### ## ##',
			phoneNumberPlaceHolder: '(___) ___ __ __'
		}
	},
	methods: {
		isPhoneNumberValid(phoneNumber) {
			if (phoneNumber.length < 15) {
				return false
			} else {
				return true
			}
		}
	}
}
